/* ==========================================================================
   Donaldson BOFA model page and parts list (V3) — assets/abi-bofa-model.js
   Loaded (defer) by sections/abi-bofa-model.liquid. Feature bofa-model-page, review/bofa-v3-finish-2026-10-23.
   The parts list's "Narrow by machine" chips: one pressed chip at a time ("All" shows everything); a card stays when its
   data-models (space-separated bofa-model and finder slugs) holds the chip's slug; a group with no card left is hidden.
   Without JS every card shows and the chips stay hidden ([data-bmo-js-only]). Text goes in through textContent only.
   ========================================================================== */
(function () {
  'use strict';
  function matches(models, slug) { return !slug || (' ' + String(models || '') + ' ').indexOf(' ' + slug + ' ') !== -1; }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { matches: matches }; return; }
  if (typeof document === 'undefined') return;
  function mount(root) {
    if (root.__bmo) return;
    root.__bmo = true;
    root.setAttribute('data-bmo-js', 'on');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-bmo-chip]'));
    if (!chips.length) return;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bmo-card]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-bmo-group]'));
    var count = root.querySelector('[data-bmo-count]');
    function apply(slug, label) {
      var shown = 0;
      cards.forEach(function (c) { var on = matches(c.getAttribute('data-models'), slug); c.hidden = !on; if (on) shown++; });
      groups.forEach(function (g) { g.hidden = !g.querySelector('[data-bmo-card]:not([hidden])'); });
      chips.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-bmo-chip') === slug ? 'true' : 'false'); });
      if (count) count.textContent = slug ? shown + ' of ' + cards.length + ' listed for the ' + label : '';
    }
    chips.forEach(function (b) {
      b.addEventListener('click', function () { apply(b.getAttribute('data-bmo-chip') || '', b.textContent.trim()); });
    });
  }
  var start = function () { var roots = document.querySelectorAll('[data-bmo]'); for (var i = 0; i < roots.length; i++) mount(roots[i]); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
